import { AJOUTER_FORMULAIRE_COORDONNEES_BANCAIRES } from './actionTypes'

export const ajouterFormulaireCoordonneesBancaires = (formulaireCoordonneesBancaires) => {
	return ({
		type: AJOUTER_FORMULAIRE_COORDONNEES_BANCAIRES,
		payload: formulaireCoordonneesBancaires
	})
}
